import * as BobPlayer from "./BobPlayer/index.js";
/** CoStar.Api.ListingUserSub.ViewModels.UrlType */
export var UrlType;
(function (UrlType) {
    UrlType[UrlType["None"] = 0] = "None";
    UrlType[UrlType["BidderRegistration"] = 1] = "BidderRegistration";
    UrlType[UrlType["BrokerRegistration"] = 2] = "BrokerRegistration";
})(UrlType || (UrlType = {}));
/** CoStar.Api.ListingUserSub.ViewModels.ListingPlan */
export var ListingPlan;
(function (ListingPlan) {
    ListingPlan[ListingPlan["None"] = 0] = "None";
    ListingPlan[ListingPlan["Individual"] = 1] = "Individual";
    ListingPlan[ListingPlan["Company"] = 2] = "Company";
    ListingPlan[ListingPlan["Unlimited"] = 3] = "Unlimited";
})(ListingPlan || (ListingPlan = {}));
/** CoStar.Api.ListingUserSub.ViewModels.BrokerHistoryResultView */
export var BrokerHistoryResultView;
(function (BrokerHistoryResultView) {
    BrokerHistoryResultView[BrokerHistoryResultView["CountsOnly"] = 0] = "CountsOnly";
    BrokerHistoryResultView[BrokerHistoryResultView["Detail"] = 1] = "Detail";
})(BrokerHistoryResultView || (BrokerHistoryResultView = {}));
export { BobPlayer };
